import React from 'react';
import Responsive from '@amzn/meridian/responsive';
import { responsiveProps } from 'src/constants/responsiveProps';
import SearchForLaptop from 'src/components/pages/search-page/search-for-laptop/SearchForLaptopContainer';
import SearchForScanner from 'src/components/pages/search-page/search-for-scanner/SearchForScannerContainer';
import Column from '@amzn/meridian/column';
import './Search.scss';

interface SearchDispatchProps {
    resetContainerState: () => void;
}

type Props = SearchDispatchProps;

class Search extends React.Component<Props, any> {

    componentWillUnmount() {
        this.props.resetContainerState();
    }

    public render() {
        return(
            <Responsive query={"max-width"} props={responsiveProps}>
                {props => (
                    <Column>
                        {!props.isScanner &&
                            <SearchForLaptop />
                        }

                        {props.isScanner &&
                            <SearchForScanner />
                        }
                    </Column>
                )}
            </Responsive>
        );
    }
}

export default Search;